import { registerReducer } from "./actions";

export default registerReducer;
